import {ModuleWithProviders, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import * as fromShipmentTimelineEvents from './+state/shipment-timeline-events.reducer';
import {ShipmentTimelineEventsEffects} from './+state/shipment-timeline-events.effects';
import {ShipmentTimelineEventsFacade} from './+state/shipment-timeline-events.facade';
import {SharedStoresShipmentTimelineEventsConfig} from "./shared-stores-shipment-timeline-events-config";

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromShipmentTimelineEvents.SHIPMENTTIMELINEEVENTS_FEATURE_KEY,
            fromShipmentTimelineEvents.reducer
        ),
        EffectsModule.forFeature([ShipmentTimelineEventsEffects]),
    ],
    providers: [ShipmentTimelineEventsFacade],
})
export class SharedStoresShipmentTimelineEventsModule {

    static forFeature(
        config: SharedStoresShipmentTimelineEventsConfig
    ): ModuleWithProviders<SharedStoresShipmentTimelineEventsModule> {
        return {
            ngModule: SharedStoresShipmentTimelineEventsModule,
            providers: [config.service]
        }
    }

}
